import { useMatch } from "react-router-dom";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { useState, useEffect } from "react";
import henceforthApi from "../utils/henceforthApi";
import { Link, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { getUserProfileImage } from "../utils/constant_value";

export default () => {
  const params = useParams();
  let limit = 10;
  const match = useMatch("/user-Message-Details/:id");
  const [getQueries, setGetQueries] = useState({});
  const queriesData = async () => {
    const getApi = await henceforthApi?.Queries?.queriesUserDetails(
      match?.params?.id
    );
    setGetQueries(getApi);
  };
  //modal for reply
  const [Reply, setReply] = useState(false);
  const handleCloseReply = () => setReply(false);
  const HandleReply = () => setReply(true);
  //Reply
  const [queriesReply, setQueriesReply] = useState({
    reply: "",
  });
  const { reply } = queriesReply;
  const onInputChange = (e) => {
    setQueriesReply({ ...queriesReply, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e, id) => {
    e.preventDefault();
    let data = {
      _id: id,
      subject:"email",
      reply: queriesReply?.reply,
    };
    try {
      await henceforthApi?.Queries?.queriesReplyApi(data);
      queriesData();
      setReply(false);
      setQueriesReply("");
      // setGetQueries(getApi.user_messages);
    } catch (error) {
    }
  };

  const [showImage, setShowImage] = useState();
  const handleShow = () => {
    setShowImage(true)
  }
  const [showCover, setShowCover] = useState();
  const handleShowCover = () => {
    setShowCover(true)
  }
  useEffect(() => {
    queriesData();
  }, []);
  return (
    <>
      {/* {getQueries.map((item, index) => ( */}
      <div>
        <div className="row animated fadeInRight">
          <div className="col-md-12" style={{ color: "#000000" }}>
            <div className="ibox">
              <div className="ibox-title">
                <h5 style={{ fontSize: "16px" }}>User Message Details</h5>
              </div>

              <div className="ibox-content">
                <div className="text-center">
                  <div className="col-sm-12">
                    <Modal
                      show={showImage}
                      onHide={() => setShowImage(false)}
                      backdrop="static"
                      keyboard={false}
                      centered
                      className="confirm-box-modal"
                    >
                      <Modal.Header closeButton>
                        {getQueries?.user_id?.full_name}
                      </Modal.Header>
                      <Modal.Body closeButton>
                        <img
                          src={getUserProfileImage(getQueries?.user_id?.profile_pic)}
                          alt="ProfileImage"
                          class="ZoomImage"
                        />
                      </Modal.Body>
                    </Modal>
                    {/* COver Image modal */}
                    <Modal
                      show={showCover}
                      onHide={() => setShowCover(false)}
                      backdrop="static"
                      keyboard={false}
                      centered
                      className="confirm-box-modal"
                    >
                      <Modal.Header closeButton>
                        {getQueries?.user_id?.full_name}
                      </Modal.Header>
                      <Modal.Body closeButton>
                        <img
                          src={getUserProfileImage(getQueries?.user_id?.cover_image)}
                          alt="ProfileImage"
                          class="ZoomImage"
                        />
                      </Modal.Body>

                    </Modal>
                  </div>
                  <div className="">
                    <img className="CoverImage"
                      onClick={() => handleShowCover(getQueries?.user_id?.cover_image)}

                      src={getUserProfileImage(getQueries?.user_id?.cover_image)} alt="" />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-4 position-relative">
                      <div className="DetailsProfileImage text-center">
                        <img
                          onClick={() => handleShow(getQueries?.profile_pic)}
                          src={getUserProfileImage(getQueries?.user_id?.profile_pic)}
                          alt="ProfileImage"
                          class="detail-img d-flex align-items-center"
                        />
                      </div>
                    </div>
                    <div className="col-md-8 DetailsProfileDetails">
                      <div className="row">
                        <div
                          className="col-sm-4"
                          style={{ textAlign: "left" }}
                        >
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              User Id
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {/* {params.page === "0"
                                  ? index + 1
                                  : (params.page - 1) * limit + (index + 1)}
                                . */}
                              {getQueries?.user_id?._id}
                            </text>
                          </div>
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              Name
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {getQueries?.user_id?.full_name}
                            </text>
                          </div>
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              Email
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {getQueries?.user_id?.email}
                            </text>
                          </div>
                        </div>
                        <div
                          className="col-sm-6 messageDeatilscol6"
                          style={{ textAlign: "left", color: "" }}
                        >
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              UserName
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {getQueries?.user_id?.username}
                            </text>
                          </div>
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              Phone
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {getQueries?.phone_no}
                            </text>
                          </div>
                          <div className="UsernameDetailsSpacing">
                            <label
                              style={{ fontSize: "12px", color: "#5E5E5E" }}
                            >
                              Date & Time
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {moment(Number(getQueries?.created_at)).format(
                                "DD MMM YYYY, h:mm a"
                              )}
                            </text>
                          </div>
                        </div>
                        <div
                          className="col-sm-2"
                          style={{ textAlign: "left", color: "" }}
                        >
                          <p
                            className="btn btn-primary align-item-right ml-10"
                            onClick={() => HandleReply(getQueries?._id)}
                          >
                            Reply
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="ibox animated fadeInRight">
              <div className="ibox-title">
                <div className="title-head d-flex justify-content-between align-items-center flex-row">
                  <div>
                    <div className="UsernameDetailsSpacing">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        Message
                      </label>
                      <br></br>
                      <text style={{ fontSize: "14px", color: "#303030" }}>
                        {" "}
                        {getQueries?.message}
                      </text>
                    </div>
                    <hr />
                    <div className="UsernameDetailsSpacing">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                 {!getQueries?.reply ? ``:`Reply` }       
                      </label>
                      <br></br>
                      <text style={{ fontSize: "14px", color: "#303030" }}>
                        {" "}
                        {getQueries?.reply}
                      </text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Modal show={Reply} onHide={handleCloseReply} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                <Link
                  to=""
                  style={{
                    textDecoration: "none",
                    color: "#000000",
                  }}
                >
                  Reply
                </Link>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={(e) => handleSubmit(e, getQueries?._id)}>
                <textarea
                  placeholder="Typing..."
                  type="text"
                  className="form-control"
                  style={{ marginBottom: "10px" }}
                  name="reply"
                  value={reply}
                  onChange={(e) => onInputChange(e)}
                />

                <button
                  className="btn btn-primary"
                  type="submit"
                  style={{ float: "right" }}
                >
                  Reply
                </button>
              </form>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      {/* ))} */}
    </>
  );
};
